/* eslint-disable */
// import { stringify as stringifyQs } from "@saleor/register/views/Register/node_modules/qs";
// import { stringifyQs } from "@saleor/utils/urls";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";
import { stringify } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";
// import { saleListPath, SaleListUrlQueryParams } from "@saleor/discounts/urls";
// import { RegisterDetailsPageTab } from "./components/RegisterDetailsPage";
// import { VoucherDetailsPageTab } from "./components/VoucherDetailsPage";

export const discountSection = "/register/";

export const saleSection = urlJoin(discountSection);
export const registerListPath = saleSection;
export enum RegisterListUrlFiltersEnum {
  type = "type",
  startedFrom = "startedFrom",
  startedTo = "startedTo",
  query = "query"
}
export enum RegisterListUrlFiltersWithMultipleValues {
  status = "status"
}
export type RegisterListUrlFilters = Filters<RegisterListUrlFiltersEnum> &
  FiltersWithMultipleValues<RegisterListUrlFiltersWithMultipleValues>;
export type RegisterListUrlDialog = "remove" | TabActionDialog;
export enum RegisterListUrlSortField {
  name = "name",
  fromEmail = "from_email",
  recommendEmail = "recommend_email",
  created = "created"
}
export type RegisterListUrlSort = Sort<RegisterListUrlSortField>;
export type RegisterListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<RegisterListUrlDialog> &
  Pagination &
  RegisterListUrlFilters &
  RegisterListUrlSort;

// export const saleListUrl = (params?: SaleListUrlQueryParams) =>
//   saleListPath + "?" + stringifyQs(params);

// export const registersListUrl = (params?: RegisterListUrlQueryParams) =>
//   registerListPath + "?" + stringifyQs(params);
export const salePath = (id: string) => urlJoin(saleSection, id);
export type RegisterUrlDialog =
  | "assign-category"
  | "assign-collection"
  | "assign-product"
  | "assign-variant"
  | "unassign-category"
  | "unassign-collection"
  | "unassign-product"
  | "unassign-variant"
  | "assign-language"
  | "remove";
export type RegisterUrlQueryParams = Pagination &
  BulkAction &
  Dialog<RegisterUrlDialog>;
// ActiveTab<RegisterDetailsPageTab>;
export const registerUrl = (id: string, params?: RegisterUrlQueryParams) =>
  salePath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const registersListUrl = (params?: RegisterListUrlQueryParams) =>
  registerListPath + "?" + stringify(params);

export const saleAddPath = urlJoin(saleSection, "add");
export const saleAddUrl = saleAddPath;

// export const voucherSection = urlJoin(discountSection, "vouchers");
// export const voucherListPath = voucherSection;
// export enum VoucherListUrlFiltersEnum {
//   startedFrom = "startedFrom",
//   startedTo = "startedTo",
//   timesUsedFrom = "timesUsedFrom",
//   timesUsedTo = "timesUsedTo",
//   query = "query"
// }
// export enum VoucherListUrlFiltersWithMultipleValues {
//   status = "status",
//   type = "type"
// }
// export type VoucherListUrlFilters = Filters<VoucherListUrlFiltersEnum> &
//   FiltersWithMultipleValues<VoucherListUrlFiltersWithMultipleValues>;
// export type VoucherListUrlDialog = "remove" | TabActionDialog;
// export enum VoucherListUrlSortField {
//   code = "code",
//   name = "name",
//   endDate = "end-date",
//   limit = "limit",
//   minSpent = "min-spent",
//   startDate = "start-date",
//   type = "type",
//   value = "value",
//   open = "isOpen",
//   displayOrder = "displayOrder"
// }
// export type VoucherListUrlSort = Sort<VoucherListUrlSortField>;
// export type VoucherListUrlQueryParams = ActiveTab &
//   BulkAction &
//   Dialog<VoucherListUrlDialog> &
//   Pagination &
//   VoucherListUrlFilters &
//   VoucherListUrlSort;
// export const voucherListUrl = (params?: VoucherListUrlQueryParams) =>
//   voucherListPath + "?" + stringifyQs(params);
// export const voucherPath = (id: string) => urlJoin(voucherSection, id);
// export type VoucherUrlDialog =
//   | "assign-category"
//   | "assign-collection"
//   | "assign-country"
//   | "assign-product"
//   | "assign-variant"
//   | "assign-language"
//   | "unassign-category"
//   | "unassign-collection"
//   | "unassign-product"
//   | "unassign-variant"
//   | "remove";
// export type VoucherUrlQueryParams = Pagination &
//   BulkAction &
//   Dialog<VoucherUrlDialog> &
//   ActiveTab<VoucherDetailsPageTab>;
// export const voucherUrl = (id: string, params?: VoucherUrlQueryParams) =>
//   voucherPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
// export const voucherAddPath = urlJoin(voucherSection, "add");
// export const voucherAddUrl = voucherAddPath;
